import FilterNav from "../../molecules/filterNav/FilterNav";
import styles from "./SearchItemContainer.module.scss";
import BoxContainer from "../../molecules/boxContainer/BoxContainer";
import PropTypes from "prop-types";
import ButtonBox from "../../atoms/buttonBox/ButtonBox";
import { isArrayNotEmpty } from "../../../utils/helperServices";

const PlanTypeMobile = (props) => {
  const resetPlan = () => {
    props.setSelectedFilter(props.tempSelectedFilter);
  };

  const handleBack = () => {
    resetPlan();
    props.hidePlanType();
  };

  return (
    <div className={styles.navGutter}>
      <FilterNav
        headingName="Plan type"
        backbtn={handleBack}
        resetClickHandler={props.resetClickHandler}
        selectedFilter={isArrayNotEmpty(props?.selectedFilter?.plantypes)}
      />
      {props.plantype.map((promo) => (
        <BoxContainer
          key={promo.label}
          boxHeading={promo.label}
          selected={props.isPlanTypeChecked(promo)}
          selectHandler={(flag) => props.plantypeClickHandler(flag, promo)}
        />
      ))}

      <ButtonBox
        children="Save Selection"
        className={styles["botton-box"]}
        click={props.hidePlanType}
      />
    </div>
  );
};

PlanTypeMobile.propTypes = {
  hidePlanType: PropTypes.bool,
  resetClickHandler: PropTypes.func,
  plantype: PropTypes.array,
  isPlanTypeChecked: PropTypes.func,
  plantypeClickHandler: PropTypes.func,
  selectedFilter: PropTypes.object,
  tempSelectedFilter: PropTypes.object
};

export default PlanTypeMobile;
